<template>
    <div class="order-address-form">
        <h2 class="order-address-form__heading">
            Lieferadresse
        </h2>
        <div class="order-address-form__form form-default">
            <delivery-address
                ref="deliveryAddress"
                :disable-early-invoice="disableEarlyInvoice"
                :early-invoice-text="earlyInvoiceText"
                :firm-required="firmRequired"
                :comment-text="commentText"
            />

            <div class="order-address-form__delivery">
                <invoice-address
                    ref="invoiceAddress"
                    :firm-required="firmRequired"
                />
            </div>

            <div class="order-address-form__form-group form-group">
                <span class="order-address-form__required-hint">
                    * Pflichtfeld
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import InvoiceAddress from './InvoiceAddress.vue';
import DeliveryAddress from './DeliveryAddress.vue';

export default {
    components: {
        InvoiceAddress,
        DeliveryAddress,
    },
    props: {
        commentText: {
            type: String,
            default: '',
        },
        disableEarlyInvoice: {
            type: Boolean,
            default: false,
        },
        earlyInvoiceText: {
            type: [String, Boolean],
            default: '',
        },
        firmRequired: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        window.scrollTo(0, 0);
    },
};
</script>




// WEBPACK FOOTER //
// Address.vue?31a2020c